<div class="footer-wrapper">
  <span class="left">{{ name }}</span>
  <span class="right">
    <img class="verifactu" [src]="'assets/img/verifactu.png'" alt="verifactu"
      [pTooltip]="'verifactu' | translate" tooltipEvent="hover" tooltipPosition="top"
      (click)="goVerifactu()" *ngIf="_.includes(this.router.url, '/billing')">
    <span>{{ year }}</span>
  </span>
</div>
